import React from 'react';
import { motion } from 'framer-motion';
const stabs = ['4:10 a.m. Alarma. Café frío en el termo.', '$1,800 de gasolina para llegar a la presa.', '$14,000 de caña, carrete y línea nueva.', '9 horas lanzando. Cero clavadas. Cero fotos.'];
export function Problem() {
  return <section className="relative w-full border-y-2 border-bone/10 bg-steel py-12 sm:py-24" aria-labelledby="problema-title" data-id="element-135" data-mp="2gekc9ernw9an">
      <div className="mx-auto max-w-5xl px-4 sm:px-8" data-id="element-136" data-mp="21od2rojmu0m3">
        <p className="font-cond text-xs uppercase tracking-[0.28em] text-blood sm:text-sm" data-id="element-137" data-mp="26gczl84eodeg">
          Hablemos claro
        </p>
        <h2 id="problema-title" className="mt-3 font-display text-2xl uppercase leading-[0.95] text-bone sm:mt-4 sm:text-5xl" data-id="element-138" data-mp="1sq9jkyw4dfxg">
          Irse en blanco no es mala suerte.
          <span className="block text-ash" data-id="element-139" data-mp="1isd7a3rg4exr">
            Es un señuelo que no se movió.
          </span>
        </h2>

        <div className="mt-8 grid gap-7 sm:mt-12 sm:gap-10 md:grid-cols-[1.1fr_0.9fr]" data-id="element-140" data-mp="1nploa10uycxf">
          <div className="space-y-4 font-body text-[0.95rem] leading-relaxed text-bone/80 sm:space-y-5 sm:text-lg" data-id="element-141" data-mp="t8m3fjz1xoi2">
            <p data-id="element-142" data-mp="oakkcz1mlp6l">
              Lo has vivido: la lobina sale del tular, se acerca, se queda a
              medio metro… y se va. No la espantaste. Simplemente no le creyó.
            </p>
            <p data-id="element-143" data-mp="xc1ttykj2smb">
              Porque ese señuelo que compraste en oferta cayó tieso. La cola se
              quedó dura como una calceta mojada, el aroma se lavó al tercer
              lance y a la segunda picada quedó desgarrado en el anzuelo. Un
              pedazo de plástico caro, importado, sin vida.
            </p>
            <p className="border-l-4 border-blood pl-4 text-bone sm:pl-5" data-id="element-144" data-mp="jdlq8ghypi8e">
              Duele más el regreso que el madrugón: la camioneta callada, la
              hielera vacía, el compa preguntando "¿y qué tal estuvo?" y tú
              contestando "estaba difícil el agua". No estaba difícil el agua.
              El pez nunca sintió nada.
            </p>
          </div>

          <ul className="space-y-2 sm:space-y-3" data-id="element-145" data-mp="1lycrn9gznszt">
            {stabs.map((stab, i) => <motion.li key={stab} initial={{
            opacity: 0,
            x: 16
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.45,
            delay: i * 0.08
          }} className="flex items-baseline gap-3 border border-bone/10 bg-abyss/60 px-4 py-3 font-cond text-base uppercase tracking-wide text-bone/85 sm:gap-4 sm:px-5 sm:py-4 sm:text-lg" data-id="element-146" data-mp="1qw4vn1uwr5kd" data-mpi={i}>
                <span className="font-display text-blood" data-id="element-147" data-mp="1cwvh06mcojii">0{i + 1}</span>
                {stab}
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}